import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MbscDraggableModule, MbscDropcontainerModule } from '@mobiscroll/angular';
import { Absence } from '../../types/absence';

// Deferred by AbsenceComponent so @mobiscroll/angular stays off the eager
// roster mapping bundle (the barrel-exported outer component kept it in the
// boot closure of every roster remote).
@Component({
  selector: 'soft-absence-mobiscroll-host',
  imports: [CommonModule, MbscDraggableModule, MbscDropcontainerModule],
  templateUrl: './absence-mobiscroll-host.component.html',
  styles: `
    :host {
      display: flex;
      flex-direction: column;
      min-height: 0;
      height: 100%;
      overflow: hidden;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AbsenceMobiscrollHostComponent {
  readonly absence = input<Absence[]>([]);

  protected $safeNavigationMigration<T>(value: T): T {
    return value;
  }
}
